import FormButtonFeedbackDo from "../../../../../../packages/design-system/form/constellation/images/form-button-feedback-do.png";
import FormButtonFeedbackDont from "../../../../../../packages/design-system/form/constellation/images/form-button-feedback-dont.png";
import FormConciseLabelDo from "../../../../../../packages/design-system/form/constellation/images/form-concise-label-do.png";
import FormConciseLabelDont from "../../../../../../packages/design-system/form/constellation/images/form-concise-label-dont.png";
import FormDefaultValuesDo from "../../../../../../packages/design-system/form/constellation/images/form-default-values-do.png";
import FormDefaultValuesDont from "../../../../../../packages/design-system/form/constellation/images/form-default-values-dont.png";
import FormGroupingDo from "../../../../../../packages/design-system/form/constellation/images/form-grouping-do.png";
import FormGroupingDont from "../../../../../../packages/design-system/form/constellation/images/form-grouping-dont.png";
import FormInputMasksDo from "../../../../../../packages/design-system/form/constellation/images/form-input-masks-do.png";
import FormInputMasksDont from "../../../../../../packages/design-system/form/constellation/images/form-input-masks-dont.png";
import FormMultipleActionButtonsDo from "../../../../../../packages/design-system/form/constellation/images/form-multiple-action-buttons-do.png";
import FormMultipleActionButtonsDont from "../../../../../../packages/design-system/form/constellation/images/form-multiple-action-buttons-dont.png";
import FormOneColumnDo from "../../../../../../packages/design-system/form/constellation/images/form-one-column-do.png";
import FormOneColumnDont from "../../../../../../packages/design-system/form/constellation/images/form-one-column-dont.png";
import FormPlaceholderDo from "../../../../../../packages/design-system/form/constellation/images/form-placeholder-do.png";
import FormPlaceholderDont from "../../../../../../packages/design-system/form/constellation/images/form-placeholder-dont.png";
import FormReflectActionDo from "../../../../../../packages/design-system/form/constellation/images/form-button-reflects-action-do.png";
import FormReflectActionDont from "../../../../../../packages/design-system/form/constellation/images/form-button-reflects-action-dont.png";
import FormRequiredFieldDo from "../../../../../../packages/design-system/form/constellation/images/form-required-field-do.png";
import FormRequiredFieldDont from "../../../../../../packages/design-system/form/constellation/images/form-required-field-dont.png";
import FormVisibleLabelDo from "../../../../../../packages/design-system/form/constellation/images/form-visible-label-do.png";
import FormVisibleLabelDont from "../../../../../../packages/design-system/form/constellation/images/form-visible-label-dont.png";
import * as React from 'react';
export default {
  FormButtonFeedbackDo,
  FormButtonFeedbackDont,
  FormConciseLabelDo,
  FormConciseLabelDont,
  FormDefaultValuesDo,
  FormDefaultValuesDont,
  FormGroupingDo,
  FormGroupingDont,
  FormInputMasksDo,
  FormInputMasksDont,
  FormMultipleActionButtonsDo,
  FormMultipleActionButtonsDont,
  FormOneColumnDo,
  FormOneColumnDont,
  FormPlaceholderDo,
  FormPlaceholderDont,
  FormReflectActionDo,
  FormReflectActionDont,
  FormRequiredFieldDo,
  FormRequiredFieldDont,
  FormVisibleLabelDo,
  FormVisibleLabelDont,
  React
};